"use client"
import { FetchMenusQuery, GetFootersQuery } from "@/apollo/generated/graphql"
import styled from "@emotion/styled"
import { usePathname } from "next/navigation"
import { FC, useRef } from "react"
import { mediaQueries, sharedTheme } from "../theme/theme"
import Analytics from "./Analytics"
import Footer from "./Footer/Footer"
import Header from "./Header/Header"

const StyledMain = styled.div<{ isHomepage: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding-bottom: 30px;
  ${mediaQueries.mobile} {
    padding-bottom: 60px;
  }
  ${mediaQueries.tablet} {
    padding-top: ${(p) => (p.isHomepage ? "0px" : "68px")};
  }
  ${sharedTheme.breakpoints.up("tablet")} {
    padding-top: ${(p) => (p.isHomepage ? "0px" : "70px")};
  }
  ${sharedTheme.breakpoints.up("laptop")} {
    padding-top: ${(p) => (p.isHomepage ? "0px" : "70px")};
  }
  ${sharedTheme.breakpoints.up("desktop")} {
    padding-top: ${(p) => (p.isHomepage ? "0px" : "106px")};
  }
  ${mediaQueries.desktopM} {
    padding-top: 0;
  }
  :focus {
    outline: 0;
  }
`

interface LayoutProps {
  locale: string
  children: React.ReactNode
  menu_data: FetchMenusQuery
  companyName: string
  projectType: string
  footer_data: GetFootersQuery
}

const Layout: FC<LayoutProps> = ({
  locale,
  children,
  menu_data,
  companyName,
  projectType,
  footer_data,
}) => {
  const mainRef = useRef<HTMLDivElement>(null)
  const pathName = usePathname()

  return (
    <>
      <Analytics
        companyName={companyName}
        locale={locale}
        projectType={projectType}
      />

      <Header header_footer_data={footer_data} />

      {/* <Cookies /> */}
      <>
        <StyledMain
          id="mainContent"
          tabIndex={-1}
          ref={mainRef}
          role="main"
          isHomepage={pathName === "/"}
        >
          {children}
        </StyledMain>
        <Footer data={footer_data} />
      </>
    </>
  )
}

export default Layout
